const ULTIMATE_SCRIPT_ID = 'ze-snippet';
const ULTIMATE_STIMULUS_CONTROLLER_NAME = 'ultimate';

function reloadScript(scriptSrc: string) {
  const newScript = document.createElement('script');
  newScript.id = ULTIMATE_SCRIPT_ID;
  newScript.setAttribute('data-controller', ULTIMATE_STIMULUS_CONTROLLER_NAME);
  newScript.src = scriptSrc;
  document.head.appendChild(newScript);
}

document.addEventListener('turbolinks:load', () => {
  const script = document.querySelector(`script[id=${ULTIMATE_SCRIPT_ID}]`);

  if (script) {
    const scriptSrc = script.src;
    script.parentNode.removeChild(script);
    reloadScript(scriptSrc);
  }
});

